<template>
  <div class="box-item">
    <div class="tab-head unselect">
      <div class="title-group"
           :class="{'title-group-tab-closed' : useTab === true && isTabOpened === false }"
           @click.stop.prevent="clickTab"
           :style="titleStyle">
        <div class="flex-between" style="width: calc(100% - 32px)">
          <h1 v-show="title"
              class="title">{{ title }}
            <tool-tip style="margin-left:4px"
                      icon="help_outline"
                      :text="tip" v-if="tip"/>
            <link-icon :link="link" v-if="link"></link-icon>
          </h1>
          <slot name="title"></slot>
        </div>

        <h3 v-show="subtitle && isTabOpened" class="subtitle" :style="subtitleStyle">{{ subtitle }}</h3>
        <i class="material-icons tab-arrow"
           @click.stop.prevent="isTabOpened=!isTabOpened">keyboard_arrow_{{ isTabOpened ? 'down' : 'up' }}</i>
        <slot name="header-right-spot"></slot>
      </div>
      <h3 v-show="bottomSubtitle && isTabOpened"
          class="bottom-subtitle"
          :style="bottmSubtitleStyle">{{ bottomSubtitle }}</h3>
    </div>

    <div class="contents" v-if="isTabOpened"><slot></slot></div>
    <div class="box-disabled" v-if="disabled"></div>
  </div>
</template>

<script>
import ToolTip from "../common/ToolTip";
import LinkIcon from "../common/LinkIcon";
export default {
  components: {LinkIcon, ToolTip},
  props: {
    title: {
      type: String
    },
    subtitle: {
      type: String,
      required: false
    },
    bottomSubtitle: {
      type: String,
      required:false
    },
    titleFlex: {    // title과 subtitle 정렬 방향 (true: flex)
      type: Boolean,
      required: false
    },
    justifyContent: {
      type: String,
      required: false
    },
    useTab: {       // 탭 헤드 사용 여부
      type: Boolean,
      default: true,
      required: false
    },
    openTab: {      // 탭 오픈 초기값
      type: Boolean,
      default: true,
      required: false
    },
    // 정보 및 주의사항 (컨텐츠 밑에 위치)
    tip: {
      type: String,
      required: false
    },
    link: {
      type: String,
      required: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },

  created() {
    this.isTabOpened = this.openTab;
  },

  data() {
    return {
      isTabOpened: false,
      selectedHelp: false
    }
  },

  methods: {
    clickOutSide() {
      this.selectedHelp = false;
    },
    clickTab() {
      if(this.useTab) this.isTabOpened ? this.isTabOpened=false : this.isTabOpened=true
    },
  },

  computed: {
    titleStyle() {
      let style = {};

      // if ( this.useTab === true &&
      //      this.isTabOpened === false) {
      //   style.paddingBottom = '0!important';
      // }
      style.width = '100%';
      style.marginBottom = '2rem';

      if ( this.useTab ) style.borderBottom = '1px solid #e5e5e5';

      if ( this.titleFlex ) {
        style.display = 'flex';
        style.flexWrap = 'wrap';
        style.alignItems = 'center';
      }

      if ( this.borderBottom ) {
        style.borderBottom = '1px solid #e5e5e5';
      }

      if ( this.titleFlex && this.justifyContent ) {
        style.justifyContent = this.justifyContent;
      }

      return style;
    },

    subtitleStyle() {
      let style = {};
      style.color = '#989898';

      if ( this.subtitle && !this.titleFlex ) {
        style.paddingTop = '8px';
      }

      if( this.titleFlex && !this.justifyContent) {
        style.margin = '4px 0 0 0';
      }

      style.marginBottom = '0';

      return style;
    },

    bottmSubtitleStyle() {
      let style = {};
      style.color = '#989898';
      style.marginBottom = '2rem';
      style.whiteSpace = 'pre-line';
      return style;
    }
  },

}
</script>

<style lang="stylus" type="stylus" scoped>

  .tab-arrow
    cursor pointer

  .title-group > i
    position absolute
    top 0
    right 0

  .title
    display flex
    align-items center

  .title:hover
    cursor pointer
    font-weight 600 !important

  .subtitle
    white-space pre-line

  .help-outside
    position fixed
    top 0
    left 0
    right 0
    bottom 0
    z-index 120
    background rgba(0,0,0, 0.3)

  .help-icon
    font-size 16px
    cursor pointer

  .tip-desc
    position absolute
    z-index 125
    left 0
    top 22px
    background-color white
    border-radius 4px
    width 300px
    padding 20px
    font-size 12px
    white-space pre-line

  .box-item
    position relative

  .box-disabled
    position absolute
    top 0
    left 0
    width 100%
    height 100%
    background-color rgba(255,255,255,0.4)
    z-index 100
</style>
